module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "apple_store_white.70197570.svg";